// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"9daac482","508":"22b4f9b1"}[chunkId] + ".chunk.js";
};